import NumberHelper from './../../../Shared/Helpers/numberHelper';

String.prototype.toFloat = function () {
    if (this.indexOf(",") >= 0 && this.indexOf(".") >= 0) {
        var val = this;
        var thousandSeparator = NumberHelper.getThousandSeparator(); 
        var decimalSeparator = NumberHelper.getDecimalSeparator();

        if (thousandSeparator)
            val = val.replace(new RegExp('\\' + thousandSeparator, 'g'), '');

        if (NumberHelper.getDecimalSeparator())
            val = val.replace(new RegExp('\\' + decimalSeparator, 'g'), '.');

        return parseFloat(val);
    }

    return parseFloat(this.replace(",", "."));
};